import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './socialHub.scss';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Toast from '../toast/Toast';

const SocialHub = ({ alignment = 'left', className = '' }) => {
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [status, setStatus] = useState('');

    const copyToClipboard = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText("olivia.rue.23@gmail.com");
        setShowToast(true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message) return;
        setStatus('Sending...');

        const encode = (data) => Object.keys(data).map(k => encodeURIComponent(k) + "=" + encodeURIComponent(data[k])).join("&");

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({
                "form-name": "contact",
                "bot-field": formData["bot-field"] || "",
                ...formData
            })
        })
            .then(() => {
                setStatus('Message sent successfully!');
                setFormData({ name: '', email: '', message: '', 'bot-field': '' });
                setTimeout(() => {
                    setStatus('');
                    setShowModal(false);
                }, 3000);
            })
            .catch(error => setStatus('Error sending message. Please try again.'));
    };

    return (
        <div className={`socialHubContainer align-${alignment} ${className}`}>
            <Toast message="Email copied to clipboard!" visible={showToast} onHide={() => setShowToast(false)} />

            <div className="socialIcons">
                <div className="socialBtn" title="Send Message" onClick={() => setShowModal(true)}>
                    <EmailOutlinedIcon className="socialIcon email" />
                </div>

                <a className="socialBtn" href="https://www.linkedin.com/in/oliviarue/" target="_blank" rel="noreferrer" title="LinkedIn">
                    <LinkedInIcon className="socialIcon linkedin" />
                </a>

                <a className="socialBtn" href="https://www.instagram.com/oliviarue" target="_blank" rel="noreferrer" title="Instagram">
                    <InstagramIcon className="socialIcon instagram" />
                </a>
            </div>

            {showModal && createPortal(
                <div className="socialModalOverlay" onClick={() => setShowModal(false)}>
                    <div className="socialModal" onClick={e => e.stopPropagation()}>
                        <div className="modalHeader">
                            <h2>Get in Touch</h2>
                            <button className="closeBtn" onClick={() => setShowModal(false)}>&times;</button>
                        </div>

                        <div className="manualContact">
                            <p>Direct Email:</p>
                            <div className="emailCopyBox">
                                <span>olivia.rue.23@gmail.com</span>
                                <button className="copyBtn" onClick={copyToClipboard} title="Copy to clipboard">
                                    <ContentCopyIcon className="copyIcon" />
                                </button>
                            </div>
                        </div>

                        <hr className="modalSeparator" />

                        <form className="socialContactForm" name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={handleSubmit}>
                            <input type="hidden" name="form-name" value="contact" />
                            <p className="hidden" style={{ display: 'none' }}>
                                <label>Don’t fill this out if you’re human: <input name="bot-field" onChange={e => setFormData({ ...formData, 'bot-field': e.target.value })} /></label>
                            </p>
                            <div className="formGroup">
                                <input type="text" name="name" placeholder="Your Name" required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                                <input type="email" name="email" placeholder="Your Email" required value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                            </div>
                            <textarea name="message" placeholder="How can I help you?" rows="5" required value={formData.message} onChange={e => setFormData({ ...formData, message: e.target.value })}></textarea>
                            <div className="formFooter">
                                <button type="submit" disabled={status === 'Sending...'}>{status === 'Sending...' ? 'Sending...' : 'Send Message'}</button>
                                {status && status !== 'Sending...' && <span className={`statusMsg ${status.includes('Error') ? 'error' : 'success'}`}>{status}</span>}
                            </div>
                        </form>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default SocialHub;
